import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ITableSet } from '../../../components/table/Table';
import TableWithPagination from '../../../components/table/tableWithPagination/TableWithPagination';
import { IState } from '../../../redux/store';
import { updateParam } from '../../../redux/progress/param/paramAction'
import { useParams } from 'react-router';
import useTableDataWithPagination from '../../../components/table/tableWithPagination/useTableDataWithPagination';
import { urls } from '../../../config/url';
import DirPickerFliter, { IDirPickerFliterData } from './DirPickerFliter';
import { IDataDirInfo } from './DataDirInfo';
import { log } from 'console';
import { IModuleParams } from '../../../redux/progress/param/paramReducer';
import {Button} from 'antd'
function FileDirPicker(props: {
    userName: string;
    activeProjectName: string;
    choosed?: IDataDirInfo;
    onChoose?: (info?: any) => void;
    modele: string,
    params: IModuleParams,
    updateParam: (param: IModuleParams) => void,
    modules: any

}) {


    const [fliter, setFliter] = useState<IDirPickerFliterData>({});

    const tableSets: ITableSet[] = [
        {
            titleId: "dir_name",
            key: "USERDATADIR_NAME"
        },
        {
            titleId: "user_name",
            key: "USER_NAME"
        },
        {
            titleId: "project_name_header",
            key: "PROJECTNAME"
        },
        {
            titleId: "speciality",
            key: "SPECIALITYCLASS"
        },
        {
            titleId: "technology",
            key: "TECHNOLOGYCLASS"
        },
        {
            titleId: 'update_time',
            key: 'update_time',
            handleSort: (a, b) => { return a - b },
            cover: (rowindex, rowData) => {
                return <>{new Date(rowData.update_time).toLocaleString()}</>
            }
        },
        // {
        //     titleId: "comment",
        //     key: ""
        // },
        {
            titleId: "empty",
            cover: (rowIndex: number, dirInfo: IDataDirInfo) => {

                return (
                    <button
                        key={rowIndex}
                        className="btn btn-primary"
                        disabled={props.choosed && props.choosed.relative_file_path === dirInfo.relative_file_path}
                        onClick={() => {
                            if (props.onChoose)
                                props.onChoose(dirInfo);
                        }}
                    >
                        选择
                    </button>
                )

            }
        }
    ]

    const { spec } = useParams<{ spec: string }>()

    const param = useTableDataWithPagination(urls.listUserDirByPage, {
        USER_NAME: props.userName,
        PROJECTNAME: props.activeProjectName,
        SPECIALITYCLASS: spec,
        FIELD_USERDATACLASS: props.modele === '' ? 2 : props.modele == 'diffraction' ? 2 : 1,
        ...fliter,
        USERDATADIR_NAME: props.params.result_dir

    });
    // if (param.data.length == 1) {
    //     if (props.onChoose)
    //         props.onChoose(param.data[0]);
    // } else {
    //     if (props.onChoose)
    //         if (props.onChoose) props.onChoose();
    // }

    useEffect(() => {
        param.update();
        // if (props.onChoose) props.onChoose();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fliter]);

    return <>
        <DirPickerFliter onChanged={(value) => setFliter(value)} value={props.modele} />
        {
            props.modules[0].TECHNIC_PREFIX === 'SWIT' ? <Button style={{position: 'absolute',right: 20 ,marginTop: '-52px',}} onClick={() => {
                props.updateParam({ ['raw_file']: "No" });
            }}>恢复默认值</Button> : ''
        }
        {/* {background: '#52C41A',border: '1px solid #52C41A',color: '#fff',
            props.modules[0].TECHNIC_PREFIX === 'SWIT' ? <button style={{ width: 85, height: 37, background: '#007BFF', color: '#fff', border: '1px solid #007BFF', borderRadius: 4, marginTop: '-52px',position: 'absolute',right: 20 }} onClick={() => {
                props.updateParam({ ['raw_file']: "No" });
            }}>恢复默认值</button> : ''
        } */}
        <TableWithPagination param={param} tableSets={tableSets} />
    </>
}

const mapStateToProps = (state: IState) => {

    return {
        userName: state.user.userName,
        activeProjectName: state.project.activeName,
        params: state.progress.params,
        modules: state.progress.modules.modules,
    };
};


export default connect(
    mapStateToProps,
    { updateParam }
)(FileDirPicker);